export default {
    NODE_ENV: process.env.NODE_ENV,
    GRAPHQL_ENDPOINT: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    WS_SERVER: process.env.REACT_APP_WS_SERVER
};
